import { render, staticRenderFns } from "./index.vue?vue&type=template&id=139210b3&scoped=true&"
import script from "./header?vue&type=script&lang=js&"
export * from "./header?vue&type=script&lang=js&"
import style0 from "./header.scss?vue&type=style&index=0&id=139210b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139210b3",
  null
  
)

export default component.exports